require('app/scripts/data/moment/en-US');

window.__intlLocaleData = require('intl/locale-data/json/en-US');

window.__locale = {
  strings: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/locales/locale-data/strings/en'),
  templates: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/locales/locale-data/templates/en'),
  counting: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/locales/locale-data/counting/en'),
  social: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/locales/locale-data/social/en'),
  banners: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/locales/locale-data/banner'),
  actions: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/strings/actions/en'),
  billing: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/strings/billing/en'),
  exports: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/strings/exports/en'),
  labels: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/strings/labels/en'),
  notifications: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/strings/notifications/en'),
  notificationsGrouped: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/locales/locale-data/notificationsgrouped/en'),
  search: require('/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3290/resources/strings/search/en')
};


//////////////////
// WEBPACK FOOTER
// ./tools/webpack/tmp/en-US.js
// module id = ./tools/webpack/tmp/en-US.js
// module chunks = 26